<template>
    <div>
      <back-btn />
      <v-container fluid>
        <v-row justify="center">
          <v-col lg="8">
            <v-card class="card--shadow">
              <v-card-text>
                <v-row>
                  <v-col class="col--padding" offset-lg="2" lg="4">
                    <label>Month</label>
                    <v-select
                      class="mr-1"
                      :items="export_months"
                      v-model="month"
                      item-text="text"
                      :error-messages="monthValidation"
                      item-value="value"
                      dense
                      outlined
                    ></v-select>
                  </v-col>
                  <v-col class="col--padding" lg="4">
                    <label>Year</label>
                    <v-select
                      class="mr-1"
                      :items="years"
                      v-model="year"
                      item-text="text"
                      item-value="value"
                      :error-messages="yearValidation"
                      dense
                      outlined
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col class="col--padding" lg="3">
                    <div>
                      <v-btn
                        height="40"
                        color="purple accent-4"
                        @click.prevent="goActivityList"
                        outlined
                        rounded
                        dark
                      >
                        Go CI
                        <v-icon right>mdi-arrow-right-thick</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions></v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </template>
  
  <script>
  import { required } from "vuelidate/lib/validators";
  import { ValidationMixin } from "./../../mixins/ValidationMixin";
  import { mapState } from "vuex";
  import BackBtn from "@/components/navigation/BackBtn.vue";
  export default {
    components: { BackBtn },
    mixins: [ValidationMixin],
    data: () => ({
      month: null,
      year: null,
    }),
    validations: {
      month: {
        required,
      },
      year: {
        required,
      },
    },
    methods: {
      goActivityList() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          this.$router.push({
            name: "ci-list",
            params: { month: this.month, year: this.year ,township_id: this.$route.params.township_id},
            // query: { township: this.$route.params.township_id },
          });
        }
      },
    },
    computed: {
      ...mapState("InitialData", ["export_months", "years"]),
      monthValidation() {
        return this.handleFieldErrors(this.$v.month);
      },
      yearValidation() {
        return this.handleFieldErrors(this.$v.year);
      },
    },
  };
  </script>
  